import React, { useState } from 'react'
import { makeStyles, useTheme } from '@mui/styles'

import lang from '@/lang'
import config from '@/config'
import CheckIcon from '@assets/images/icons/check.svg'
import AbortIcon from '@assets/images/icons/close.svg'
import { TextInput } from '@/modules/base/components/inputs'
import { SquareIconButton } from '@/modules/base/components/buttons'
import ThemeInterface from '@/theme-interface'
import { MultiSelectTypes } from '@/components/multi-select/constants'
import buildName from '@/modules/todo/components/_helpers/buildName'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 15,
  },
  nameInput: {
    marginBottom: 15,
  },
  abort: {
    marginRight: 10,
  },
}))

type NewItemFormTypes = {
  item: { name: string, email?: string, multiSelectType: MultiSelectTypes },
  onSave: (item: { name: string, email: string, multiSelectType: MultiSelectTypes }) => void,
  onAbort: () => void
}

const NewItemForm = (props: NewItemFormTypes) => {
  const classes = useStyles()
  const theme = useTheme<ThemeInterface>()
  const { item, onSave, onAbort } = props
  const [name, setName] = useState<string>(item?.name || buildName(item))
  const [email, setEmail] = useState<string>(item?.email)
  const [hasEmailError, setEmailError] = useState<boolean>(false)
  const isValid = email && name

  const onNameChange = (value) => {
    setName(value)
  }
  const onEmailChange = (value) => {
    setEmail(value)
  }
  const onEmailBlur = (value) => {
    if (!config.emailCheck.test(value) || !value) {
      setEmailError(true)
    } else {
      setEmailError(false)
    }
  }
  const save = () => {
    if (!name || !email) { return }
    onSave && onSave({ ...item, name, email, multiSelectType: item?.multiSelectType ?? MultiSelectTypes.External })
  }
  const abort = () => {
    onAbort()
  }

  return (
    <div className={classes.root}>
      <TextInput
        name='nameInput'
        required
        useFormik={false}
        className={classes.nameInput}
        disabled={item?.multiSelectType !== MultiSelectTypes.External}
        label={`${lang.multiSelect.addForm.inputs.name}*`}
        value={name}
        onChange={onNameChange} />
      <TextInput
        name='emailInput'
        required
        useFormik={false}
        errorMessage={hasEmailError && lang.multiSelect.addForm.error.email}
        label={`${lang.multiSelect.addForm.inputs.email}*`}
        value={email}
        onChange={onEmailChange}
        onBlur={onEmailBlur} />
      <div className={classes.buttons}>
        <SquareIconButton
          className={classes.abort}
          icon={AbortIcon}
          iconColor={theme.red}
          onClick={abort} />
        <SquareIconButton
          icon={CheckIcon}
          iconColor={theme.primary}
          disabled={hasEmailError || !isValid}
          onClick={save} />
      </div>
    </div>
  )
}

export default NewItemForm
